import { render, staticRenderFns } from "./TitleComponent.vue?vue&type=template&id=00f1c76e&scoped=true"
import script from "./TitleComponent.vue?vue&type=script&lang=js"
export * from "./TitleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1c76e",
  null
  
)

export default component.exports